import jsVectorMap from 'jsvectormap';

window.JsVectorMap = jsVectorMap;
window.JsVectorMap.prototype.addMap = jsVectorMap.addMap.bind(jsVectorMap);
require('../../js/us-aea-en.min.js');

const STATE_NAMES = {
    'US-AL': 'Alabama', 'US-AK': 'Alaska', 'US-AZ': 'Arizona', 'US-AR': 'Arkansas',
    'US-CA': 'California', 'US-CO': 'Colorado', 'US-CT': 'Connecticut', 'US-DE': 'Delaware',
    'US-FL': 'Florida', 'US-GA': 'Georgia', 'US-HI': 'Hawaii', 'US-ID': 'Idaho',
    'US-IL': 'Illinois', 'US-IN': 'Indiana', 'US-IA': 'Iowa', 'US-KS': 'Kansas',
    'US-KY': 'Kentucky', 'US-LA': 'Louisiana', 'US-ME': 'Maine', 'US-MD': 'Maryland',
    'US-MA': 'Massachusetts', 'US-MI': 'Michigan', 'US-MN': 'Minnesota', 'US-MS': 'Mississippi',
    'US-MO': 'Missouri', 'US-MT': 'Montana', 'US-NE': 'Nebraska', 'US-NV': 'Nevada',
    'US-NH': 'New Hampshire', 'US-NJ': 'New Jersey', 'US-NM': 'New Mexico', 'US-NY': 'New York',
    'US-NC': 'North Carolina', 'US-ND': 'North Dakota', 'US-OH': 'Ohio', 'US-OK': 'Oklahoma',
    'US-OR': 'Oregon', 'US-PA': 'Pennsylvania', 'US-RI': 'Rhode Island', 'US-SC': 'South Carolina',
    'US-SD': 'South Dakota', 'US-TN': 'Tennessee', 'US-TX': 'Texas', 'US-UT': 'Utah',
    'US-VT': 'Vermont', 'US-VA': 'Virginia', 'US-WA': 'Washington', 'US-WV': 'West Virginia',
    'US-WI': 'Wisconsin', 'US-WY': 'Wyoming', 'US-DC': 'Washington D.C.',
};

const stateName = (code) => STATE_NAMES[code] || code.replace('US-', '');

const parseRegionColors = (rawRegions) => {
    const regionColors = {};

    if (!rawRegions) return regionColors;

    rawRegions.split(',').filter(Boolean).forEach((entry) => {
        const [code, color] = entry.trim().split(':');
        const key = code.trim().includes('-') ? code.trim() : `US-${code.trim()}`;
        regionColors[key] = color.trim();
    });

    return regionColors;
};

export function MapBlock() {
    const staticMapEls = document.querySelectorAll('[data-map-static]');
    const mapEls = document.querySelectorAll('[data-map]');

    staticMapEls.forEach((el) => {
        const rawRegions = el.dataset.regions || '';
        const DEFAULT_COLOR = '#c7cfd8';
        const regionColors = parseRegionColors(rawRegions);

        const staticMap = new jsVectorMap({
            selector: `#${el.id}`,
            map: 'us_aea_en',
            backgroundColor: 'transparent',
            regionStyle: {
                initial: { fill: DEFAULT_COLOR, stroke: '#ffffff', strokeWidth: 0.5 },
                hover: { cursor: 'default', fillOpacity: 1 },
            },
            showTooltip: false,
            onRegionClick: () => false,
            markers: [],
            zoomOnScroll: false,
            zoomButtons: false,
        });

        Object.entries(regionColors).forEach(([code, color]) => {
            const region = staticMap.regions[code];
            if (region?.element) region.element.setStyle('fill', color);
        });

        window.addEventListener('resize', () => staticMap.updateSize());
    });

    if (!mapEls.length) return;

    // Blur focused element before any modal sets aria-hidden on close
    document.addEventListener('hide.bs.modal', (e) => {
        if (document.activeElement && e.target.contains(document.activeElement)) {
            document.activeElement.blur();
        }
    }, true);

    mapEls.forEach((el) => {

        const rawRegions   = el.dataset.regions || '';
        const rawActiveStates = el.dataset.activeStates || '';
        const rawPendingStates = el.dataset.pendingStates || '';
        const modalId      = el.dataset.modalId || '';
        const modalEl      = modalId ? document.getElementById(modalId) : null;
        const stateSelect  = el.closest('.map-block__layout')?.querySelector('.map-block__select') || null;

        const ACTIVE_HOVER_COLOR = '#034B79';
        const PENDING_HOVER_COLOR = '#4F9FCE';
        const INACTIVE_HOVER_COLOR = '#B6C0CB';
        const DEFAULT_COLOR   = '#c7cfd8';
        let activeCode = null;

        const activeHoverStates = new Set(
            rawActiveStates.split(',').map((code) => code.trim()).filter(Boolean)
        );
        const pendingHoverStates = new Set(
            rawPendingStates.split(',').map((code) => code.trim()).filter(Boolean)
        );

        const statusHoverColor = (code) => {
            if (activeHoverStates.has(code)) return ACTIVE_HOVER_COLOR;
            if (pendingHoverStates.has(code)) return PENDING_HOVER_COLOR;
            return INACTIVE_HOVER_COLOR;
        };

        // Parse "CODE" or "CODE:color" entries into a lookup map
        const regionColors = parseRegionColors(rawRegions);

        const baseColor  = (code) => regionColors[code] ?? DEFAULT_COLOR;

        const setRegionColor = (code, color) => {
            const region = mapInstance?.regions[code];
            if (region?.element) region.element.setStyle('fill', color);
        };

        const showModal = () => {
            if (modalEl && window.bootstrap) {
                window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
            }
        };

        const clearActiveState = () => {
            if (!activeCode) return;
            setRegionColor(activeCode, baseColor(activeCode));
            activeCode = null;
            if (stateSelect) stateSelect.value = '';
        };

        const activateState = (code) => {
            if (!mapInstance) return;

            if (activeCode && activeCode !== code) {
                setRegionColor(activeCode, baseColor(activeCode));
            }

            if (activeCode === code) {
                activeCode = null;
                if (stateSelect) stateSelect.value = '';
                return;
            }

            activeCode = code;
            setRegionColor(code, statusHoverColor(code));
            if (stateSelect) stateSelect.value = code;

            // Let listeners (e.g. the sales form's hidden title field) capture the clicked state
            document.dispatchEvent(new CustomEvent('mapStateSelected', {
                detail: { state: code, stateName: stateName(code) }
            }));

            if (modalEl && window.bootstrap) {
                modalEl.querySelectorAll('.map-modal__state-panel').forEach((p) => { p.hidden = true; });
                const panel = modalEl.querySelector(`.map-modal__state-panel[data-key="${code}"]`);
                if (panel) panel.hidden = false;
                showModal();
            }
        };

        if (modalEl) {
            modalEl.addEventListener('click', (e) => {
                if (!e.target.closest('.map-modal__cta')) return;
                const salesModalEl = document.querySelector('#salesModal');
                if (salesModalEl && window.bootstrap) {
                    setTimeout(() => window.bootstrap.Modal.getOrCreateInstance(salesModalEl).show(), 400);
                }
            });

            modalEl.addEventListener('hidden.bs.modal', () => {
                clearActiveState();
            });
        }

        let mapInstance = new jsVectorMap({
            selector: `#${el.id}`,
            map: 'us_aea_en',
            backgroundColor: 'transparent',
            regionStyle: {
                initial: { fill: DEFAULT_COLOR, stroke: '#ffffff', strokeWidth: 0.5 },
                hover:   { cursor: 'default', fillOpacity: 1 },
            },
            showTooltip: true,
            onRegionTooltipShow(event, tooltip, code) {
                tooltip.text(stateName(code));
            },
            onRegionClick(event, code) {
                if (activeCode === code) { showModal(); return; }
                activateState(code);
            },
            markers: [],
            zoomOnScroll: false,
            zoomButtons: false,
        });

        window.addEventListener('resize', () => mapInstance.updateSize());

        document.addEventListener('click', (e) => {
            if (!activeCode) return;
            if (el.contains(e.target)) return;
            if (modalEl?.contains(e.target)) return;
            if (stateSelect?.contains(e.target)) return;
            clearActiveState();
        });

        // Keyboard accessibility + tooltip positioning
        const tooltipEl = document.querySelector('.jvm-tooltip');
        Object.keys(mapInstance.regions).forEach((code) => {
            const region = mapInstance.regions[code];
            if (!region?.element?.shape) return;
            const node  = region.element.shape.node;
            const label = stateName(code);

            node.style.cursor = 'pointer';
            node.setAttribute('tabindex', '0');
            node.setAttribute('role', 'button');
            node.setAttribute('aria-label', label);

            node.addEventListener('focus', () => {
                if (!tooltipEl) return;
                const rect    = node.getBoundingClientRect();
                const tipRect = tooltipEl.getBoundingClientRect();
                tooltipEl.textContent = label;
                tooltipEl.classList.add('active');
                tooltipEl.style.left = `${rect.left + rect.width / 2 - tipRect.width / 2 + window.scrollX}px`;
                tooltipEl.style.top  = `${rect.top - tipRect.height - 8 + window.scrollY}px`;
            });
            node.addEventListener('blur',    () => tooltipEl?.classList.remove('active'));
            node.addEventListener('mouseenter', () => setRegionColor(code, statusHoverColor(code)));
            node.addEventListener('mouseleave', () => {
                setRegionColor(code, activeCode === code ? statusHoverColor(code) : baseColor(code));
            });
            node.addEventListener('keydown', (e) => {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                e.preventDefault();
                activeCode === code ? showModal() : activateState(code);
            });
        });

        // Apply region colors
        Object.entries(regionColors).forEach(([code, color]) => setRegionColor(code, color));

        // Dropdown
        if (stateSelect) {
            stateSelect.addEventListener('change', () => {
                const code = stateSelect.value;
                if (!code) {
                    clearActiveState();
                    return;
                }
                if (activeCode === code) activeCode = null;
                activateState(code);
            });
        }
    });
}

